import React from 'react';
import CityCard from '../CityCard';
import { Bot } from 'lucide-react';
import { GAME_MODES, GAME_STATES } from '../../mock/gameData';

const TrickDisplay = ({ currentTrick, gameMode, gameState, aiInfo, deckColors }) => {
  if (!currentTrick.player1Card && !currentTrick.player2Card) {
    return null;
  }

  return (
    <div className="mb-8">
      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
        <h3 className="text-lg font-bold text-white text-center mb-4">Current Trick</h3>
        <div className="flex justify-center gap-8">
          <div className="text-center">
            <p className="text-white mb-2 font-semibold">
              {gameMode === GAME_MODES.HUMAN_VS_COMPUTER ? 'You' : 'Player 1'}
            </p>
            {currentTrick.player1Card ? (
              <CityCard 
                card={currentTrick.player1Card} 
                isPlayable={false} 
                showRank={false} 
                deckColors={deckColors} 
              />
            ) : (
              <div className="w-24 h-36 rounded-xl border-2 border-dashed border-gray-400 bg-gray-600/30 flex items-center justify-center">
                <span className="text-gray-400 text-xs">Waiting...</span>
              </div>
            )}
          </div>
          <div className="text-center">
            <p className="text-white mb-2 font-semibold flex items-center justify-center gap-2">
              {gameMode === GAME_MODES.HUMAN_VS_COMPUTER ? (
                <>
                  <Bot className="w-4 h-4" />
                  <span className={aiInfo?.color}>{aiInfo?.name}</span>
                </>
              ) : (
                'Player 2'
              )}
            </p>
            {currentTrick.player2Card ? (
              <CityCard 
                card={currentTrick.player2Card} 
                isPlayable={false} 
                showRank={false} 
                deckColors={deckColors} 
              />
            ) : (
              <div className="w-24 h-36 rounded-xl border-2 border-dashed border-gray-400 bg-gray-600/30 flex items-center justify-center">
                <span className="text-gray-400 text-xs">
                  {gameState === GAME_STATES.AI_THINKING ? 'Thinking...' : 'Waiting...'}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrickDisplay;